import { Component, Input, HostBinding, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { PrimeThemeService } from '../../../themes/prime-theme.service';

@Component({
  selector: 'app-video-card',
  templateUrl: 'video-card.component.html',
  styleUrls: ['video-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VideoCardComponent {
  // Signal-based inputs
  conversationId = input.required<string>();
  attachmentId = input.required<string>();
  attachmentName = input.required<string>();
  attachmentSize = input<string>();
  currentTabIndex = input<string>();
  previewMode = input<boolean>(false);

  /**
   * Binds the `attachmentName` property to the `data-attachment-name` attribute in the DOM.
   * This allows the DOM element to reflect the name of the attachment for accessibility or testing purposes.
   */
  @HostBinding('attr.data-attachment-name')
  get dataAttachmentName() {
    return this.attachmentName();
  }

  constructor(public primeThemeService: PrimeThemeService) {}
}
